<mat-toolbar class="sidenav-header">
  <div class="menu-container">

    <div class="pg-title">
      {{ uploaderTitle }}
    </div>

    <button mat-icon-button (click)="onPopupClose($event)">
      <mat-icon>closed</mat-icon>
    </button>

  </div>
</mat-toolbar>

<mat-divider></mat-divider>

<div class="form-field">

  <div class="upload-container">
    <div class="value-f">Upload File</div>

    <button mat-icon-button (click)="fileInputCL.click()" type="button">
      <img src="assets/icons/upload-icon.png" alt="" />
    </button>

    <input #Image #fileInputCL type="file" name="uploadedFile" style="display: none" (change)="onFileChange($event)" />
  </div>

  <div *ngIf="uploadedFile" class="extra-upload-container">
    <span class="underlined-blue">
      {{ uploadedFile.name }}
    </span>

    <button mat-icon-button (click)="onFileDelete()" type="button">
      <mat-icon>cancel</mat-icon>
    </button>
  </div>
  <br>

  <div class="form-field-container" *ngIf="serviceType === 'External Vouchers'">
  <mat-form-field appearance="outline" class="full-width">
    <mat-select [(ngModel)]="selectedPartnerId" id="partner" name="partner" placeholder="Select a Partner">
      <mat-option *ngFor="let p of externalVoucherPartnerList" [value]="p.id">
        {{ p.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>
 </div>


  <mat-divider></mat-divider>

  <button style="margin-top: 24px" [disabled]="!uploadedFile" mat-raised-button color="primary" class="full-width"
    (click)="onFileUpload()">
    Upload
  </button>

  <!--
  <div class="file-extension-note">
    Allowed file types: {{ getAllowedFileExtensions() }}
  </div>
  -->

</div>